import React from "react";
import { useAppSelector } from "src/stores/redux/hooks";
import { getIsDiscoverPIISidebarOpen, getIsSentinelLiveMonitorSidebarOpen } from "../../helpers/selectors";
import { DiscoverPIIPanelWrapper } from "./discover-pii-panel-sidebar";
import { SentinelLiveMonitorWrapper } from "./sentinel-live-monitor-sidebar";

type Props = { appName?: string };

const PIISidebarsWrapper = ({ appName }: Props) => {
    const isDiscoverPIISidebarOpen = useAppSelector(getIsDiscoverPIISidebarOpen);
    const isSentinelLiveMonitorSidebarOpen = useAppSelector(getIsSentinelLiveMonitorSidebarOpen);

    if (isDiscoverPIISidebarOpen) return <DiscoverPIIPanelWrapper />;
    else if (isSentinelLiveMonitorSidebarOpen) return <SentinelLiveMonitorWrapper appName={appName} />;
    return null;
};

export default PIISidebarsWrapper;
